module.exports = __webpack_public_path__ + "static/img/4473_phase_function_Paper_PointsHejduk_Prediction.fdd1d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4473_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VGPD
// module chunks = 0